import {
  appLogout,
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@betty/toolkit/state';
import WalletService from '../../services/WalletService/WalletService';
import { CashBalanceState, UserBalanceResponse } from './cashBalance.types';

export const getCashBalance = createAsyncThunk('cashBalance/get', async () => {
  const { balances } = await WalletService.getCashBalance();
  const cashBalance = balances.find(
    (balance: UserBalanceResponse) => balance.type === 'Cash',
  );
  const bonusBalance = balances.find(
    (balance: UserBalanceResponse) => balance.type === 'Bonus',
  );

  return {
    cash: cashBalance?.amount,
    bonus: bonusBalance?.amount,
  };
});

const initialState: CashBalanceState = {
  data: {
    cash: 0,
    bonus: 0,
  },
  dataState: 'idle',
};

const cashBalance = createSlice({
  name: 'cashBalance',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getCashBalance.pending, (state) => {
      if (state.dataState === 'fulfilled') {
        state.dataState = 'refreshing';
      } else {
        state.dataState = 'pending';
      }
    });

    builder.addCase(getCashBalance.fulfilled, (state, { payload }) => {
      state.dataState = 'fulfilled';
      state.data = {
        ...state.data,
        cash: payload.cash ?? state.data.cash,
        bonus: payload.bonus ?? state.data.bonus,
      };
    });

    builder.addCase(getCashBalance.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(appLogout, (state) => {
      Object.assign(state, initialState);
    });
  },
});

const withCashBalance = injectSlice({
  reducerPath: 'cashBalance',
  reducer: cashBalance.reducer,
});

export const selectCashBalance = withCashBalance.selector(
  (state) => state.cashBalance.data.cash,
);
export const selectBonusBalance = withCashBalance.selector(
  (state) => state.cashBalance.data.bonus,
);
export const selectCashBalanceDataState = withCashBalance.selector(
  (state) => state.cashBalance.dataState,
);

declare global {
  interface LazyLoadedSlices {
    cashBalance: ReturnType<typeof cashBalance.reducer>;
  }
}
